import {
  counterWithIconVariantIcon,
  counterPrefixIcon,
  counterUnitIcon,
  counterSuffixIcon,
} from '../icons';
import { DEFAULT_CSS_CLASS } from '@constants';

import ReactDOMServer from 'react-dom/server';

const prefixIcon = ReactDOMServer.renderToStaticMarkup(counterPrefixIcon);
const unitIcon = ReactDOMServer.renderToStaticMarkup(counterUnitIcon);
const suffixIcon = ReactDOMServer.renderToStaticMarkup(counterSuffixIcon);

const defaultBlockCssClass = DEFAULT_CSS_CLASS.COUNTER;

const counterWithIcons = {
  name: 'counter-with-icons',
  title: 'Counter with Icons',
  icon: counterWithIconVariantIcon,
  scope: ['block'],
  attributes: {
    blockClassNames: [
      {
        value: `${defaultBlockCssClass}--dlt`,
        label: 'Dlt',
      },
    ],
  },
  innerBlocks: [
    [
      'core/heading',
      {
        placeholder: 'Title',
        level: 2,
        className: `${defaultBlockCssClass}__t`,
      },
    ],
    [
      'b3rg/div',
      {},
      [
        [
          'b3rg/span',
          {
            blockClassNames: [
              { value: `${defaultBlockCssClass}__p`, label: 'Prefix' },
            ],
          },
          [['b3rg/icon-block', { icon: prefixIcon, width: 40 }]],
        ],
        ['b3rg/count', {}],
        [
          'b3rg/span',
          {
            blockClassNames: [
              { value: `${defaultBlockCssClass}__u`, label: 'Unit' },
            ],
          },
          [['b3rg/icon-block', { icon: unitIcon, width: 40 }]],
        ],
        [
          'b3rg/span',
          {
            blockClassNames: [
              { value: `${defaultBlockCssClass}__s`, label: 'Suffix' },
            ],
          },
          [['b3rg/icon-block', { icon: suffixIcon, width: 40 }]],
        ],
      ],
    ],
    [
      'core/paragraph',
      {
        placeholder: 'Description',
        className: `${defaultBlockCssClass}__d`,
      },
    ],
  ],
};

export default counterWithIcons;
